const toDataURL = (url: string) => {
  const promise = new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      if (xhr.status >= 400) {
        reject(new Error(`Failed to load image (${xhr.status})`));
        return;
      }
      var reader = new FileReader();
      reader.readAsDataURL(xhr.response);
      reader.onloadend = function() {
        resolve({ base64Url: reader.result });
      };
      reader.onerror = function() {
        reject(reader.error || new Error('Failed to read image'));
      };
    };
    xhr.onerror = function() {
      reject(new Error('Failed to load image'));
    };
    xhr.onabort = function() {
      reject(new Error('Image load aborted'));
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  });

  return promise;
};
export { toDataURL };
